module.exports = __webpack_public_path__ + "static/media/PhoneScreen3.dd0c9ccb.png";